import { render, staticRenderFns } from "./AppMultiImagesUploader.vue?vue&type=template&id=20230950&scoped=true&"
import script from "./AppMultiImagesUploader.vue?vue&type=script&lang=ts&"
export * from "./AppMultiImagesUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AppMultiImagesUploader.vue?vue&type=style&index=0&id=20230950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20230950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VImg,VProgressCircular})
